// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"218":"c61539600c8959a2bdc7","691":"2b987228cc3b606994b8","731":"ba1103855a4797096bb2","843":"42dc86e82ca83544288d"}[chunkId] + ".js";
};